;(function() {

    /** colle la sidebar des page CMS **/
    function stickySidebar(){
        var $window = $(window);

        var $header = $("#header");
        var $main = $("main");
        var $cover = $("#cover");

        var $sidebar = $("#side-bar");
        var $box = $sidebar.find(".box");
        var $content = $(".flexible-content");

        var $poscontent = $content.offset().top;
        var $heightdocument = ($main.height() + $header.height() + $cover.height()) - ($box.height() / 2);

        if($window.scrollTop() > $poscontent){
            $box.addClass("fixed");
            if($window.scrollTop() > $heightdocument){
                $box.removeClass("fixed");
            }
        }else{
            $box.removeClass("fixed");
        }

        $box.outerWidth($sidebar.width());

        $window.resize(function(){
            $box.outerWidth($sidebar.width());
        });
    }
    
    /** gestion de la sidebar CMS (active etc) **/
    function eventSidebar(){
        var $sidebar = $("#side-bar");
        var $sidebaritem = $sidebar.find("li");

        $sidebar.find("li:first-child").addClass("active");

        $sidebaritem.click(function(){
            var $this = $(this);
            $sidebaritem.removeClass("active");

            $this.addClass("active");
        });
    }


    /** map footer **/
    function initMap() {
        var adresse = new google.maps.LatLng(45.9679329, 5.25244859999998);
        var map = new google.maps.Map(document.getElementById('map-footer'), {
            center: adresse,
            zoom: 15
        });

        marker = new google.maps.Marker({
            position : map.getCenter(),
            map      : map,
            icon: "/wp-content/themes/256couleurs/assets/dist/images/marker.png",
            animation: google.maps.Animation.DROP
        });
    }

    /** tooltip pour définition **/
    function tooltip256(item){
        $("."+item).hover(function(){
            var $this = $(this);
            var $title = $this.attr("title");
            var $content = $this.attr("alt");
            var $tpl = '<div class="box-tooltip256"><div><strong>'+$title+'</strong>'+$content+'</div></div>';

            if($(".box-tooltip256").length == 0){
                $this.append($tpl);
            }
        },function(){
            //nav_timer = setTimeout(function(){$(".box-tooltip256").remove()},700);
            $(".box-tooltip256").remove();
        });
    }

    $(document).ready(function(){
        if($("body").hasClass("home")){
            function easeOutBounce (x) {
                var base = -Math.cos(x * (0.5 * Math.PI)) + 1;
                var rate = Math.pow(base,1.5);
                var rateR = Math.pow(1 - x, 2);
                var progress = -Math.abs(Math.cos(rate * (2.5 * Math.PI) )) + 1;
                return (1- rateR) + (progress * rateR);
            }

            var timing,
                timingProps = {
                    type: 'delayed',
                    duration: 150,
                    start: 'autostart',
                    pathTimingFunction: Vivus.LINEAR,
                    animTimingFunction: Vivus.LINEAR
                };

            function timingTest (buttonEl, property, type) {
                var activeSibling = buttonEl.parentNode.querySelector('button.active');
                activeSibling.classList.remove('active');
                buttonEl.classList.add('active');

                timingProps.type = (property === 'type') ? type : timingProps.type;
                timingProps.pathTimingFunction = (property === 'path') ? Vivus[type] : timingProps.pathTimingFunction;
                timingProps.animTimingFunction = (property === 'anim') ? Vivus[type] : timingProps.animTimingFunction;

                timing && timing.stop().destroy();
                timing = new Vivus('timing-example', timingProps);
            }
            diagram
            var screen = new Vivus('screen', {type: 'scenario-sync', duration: 15, forceRender: false}),
                diagram = new Vivus('diagram', {type: 'scenario-sync', duration: 15, forceRender: false}),
                pirate = new Vivus('pirate', {type: 'scenario-sync', duration: 15, forceRender: false}),
                arrow = new Vivus('arrow', {type: 'delayed', duration: 40, forceRender: false});
        }

        if($("body").hasClass("error404")){
            function easeOutBounce (x) {
                var base = -Math.cos(x * (0.5 * Math.PI)) + 1;
                var rate = Math.pow(base,1.5);
                var rateR = Math.pow(1 - x, 2);
                var progress = -Math.abs(Math.cos(rate * (2.5 * Math.PI) )) + 1;
                return (1- rateR) + (progress * rateR);
            }

            var timing,
                timingProps = {
                    type: 'delayed',
                    duration: 150,
                    start: 'autostart',
                    pathTimingFunction: Vivus.LINEAR,
                    animTimingFunction: Vivus.LINEAR
                };

            function timingTest (buttonEl, property, type) {
                var activeSibling = buttonEl.parentNode.querySelector('button.active');
                activeSibling.classList.remove('active');
                buttonEl.classList.add('active');

                timingProps.type = (property === 'type') ? type : timingProps.type;
                timingProps.pathTimingFunction = (property === 'path') ? Vivus[type] : timingProps.pathTimingFunction;
                timingProps.animTimingFunction = (property === 'anim') ? Vivus[type] : timingProps.animTimingFunction;

                timing && timing.stop().destroy();
                timing = new Vivus('timing-example', timingProps);
            }
            diagram
            var boat = new Vivus('boat', {type: 'delayed', duration: 30, forceRender: false});
        }

        $(".toggle-nav").click(function(){
            $("#main-nav").toggleClass("open");
        });

        $(".scroll_to").click(function(e    ){
            var $link = $(this).attr("href");
            var $position = $($link).offset().top;

            $("html,body").animate({"scrollTop":$position},500);

            e.preventDefault();
        });


        $("main").each(function(){
            var $this = $(this);
            var $subject = $this.attr("data-subject");
            var $select = $("#for-subject-321");

            if($subject != ""){
                $select.find('option[value="'+$subject+'"]').prop('selected', true);
            }

        });

        if($("body").hasClass("page-template-cms")){
            stickySidebar();
            $(window).scroll(function(){
                stickySidebar();
            });

            eventSidebar();

            $(".testimony").owlCarousel({
                loop:true,
                margin:0,
                nav:false,
                items:1,
                autoplay:true
            });
        }


        initMap();
        tooltip256("tooltip256");





    });
})(jQuery);